<script>
export default {
  name: "ExternalTools"
}
</script>
<template></template>
